import script from "./HeaderChatResendModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderChatResendModal.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderChatResendModal.vue?vue&type=style&index=0&id=7fc0463a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fc0463a"]])

export default __exports__